import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

const MOBILE_BREAKPOINT_PX = 768;

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly sidebarVisible = new BehaviorSubject<boolean>(true);

  readonly sidebarVisible$: Observable<boolean> = this.sidebarVisible.asObservable();

  constructor() {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined') {
      this.sidebarVisible.next(!this.isMobileWidth(window.innerWidth));
      window.addEventListener('resize', () => this.onResize());
    }
  }

  get isSidebarVisible(): boolean {
    return this.sidebarVisible.value;
  }

  isMobile(): boolean {
    if (typeof window === 'undefined') return false;
    return window.innerWidth <= MOBILE_BREAKPOINT_PX;
  }

  toggleSidebar(): void {
    this.sidebarVisible.next(!this.sidebarVisible.value);
  }

  setSidebarOpen(open: boolean): void {
    this.sidebarVisible.next(open);
  }

  private isMobileWidth(width: number): boolean {
    return width <= MOBILE_BREAKPOINT_PX;
  }

  private onResize(): void {
    if (typeof window === 'undefined') return;
    const isMobile = this.isMobileWidth(window.innerWidth);
    if (isMobile && this.sidebarVisible.value) {
      this.sidebarVisible.next(false);
    }
  }
}
